<ng-container *ngFor="let data of dashboardCompetitionsLast">
  <nz-skeleton
    [nzActive]="true"
    *ngIf="data.load"
    [nzLoading]="data.load"
    class="py-3 max-sm:pt-3"
  >
  </nz-skeleton>

  <ng-container *ngIf="!data.load && data.data.length > 0">
    <span
      class="bg-red-2 py-1 px-4 rounded-[30px] text-white font-roboto-400 text-15 max-sm:text-11 max-sm:px-2"
    >
      {{ data.date }}
    </span>
    <ng-container *ngIf="data.data && data.data.length > 0">
      <app-scores-football-team
        [dashboardSport]="{
          date: data.dateSearch,
          filter: 'All',
          today: false,
          dashboard: data.data
        }"
        [showScore]="true"
        *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
      >
      </app-scores-football-team>
      <app-scores-sports-team
        [dashboardSport]="{
          date: data.dateSearch,
          filter: 'All',
          today: false,
          dashboard: data.data
        }"
        *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
      ></app-scores-sports-team>
    </ng-container>
    <app-no-result
      *ngIf="!data.data || (data.data && data.data.length === 0)"
    ></app-no-result>
  </ng-container>
</ng-container>
